
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 300 300"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(77 82)"}},[_c('rect',{attrs:{"fill":"none","stroke-width":"5","width":"80","height":"136","rx":"3"}}),_c('path',{attrs:{"d":"M37 85h6a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6a1 1 0 011-1zm20 0h6a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6a1 1 0 011-1zm-14 28a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6a1 1 0 011-1h6zm-20 0a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6a1 1 0 011-1h6zm40 0a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6a1 1 0 011-1h6zM43 99a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6a1 1 0 011-1h6zm-20 0a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6a1 1 0 011-1h6zm40 0a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6a1 1 0 011-1h6zM23 85a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6a1 1 0 011-1h6zm20-14a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6a1 1 0 011-1h6zm20 0a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6a1 1 0 011-1h6zm-40 0a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6a1 1 0 011-1h6z"}}),_c('rect',{attrs:{"x":"16","y":"14","width":"48","height":"48","rx":"2"}}),_c('path',{attrs:{"d":"M131 41c8 0 13 6.046 13 13.5V64h7v31h-40V64h7v-9.5c0-7.454 5-13.5 13-13.5zm0 31c-2.429 0-4.4 2.016-4.4 4.5a4.5 4.5 0 002.2 3.877V85.5h4.4v-5.123a4.5 4.5 0 002.2-3.877c0-2.484-1.971-4.5-4.4-4.5zm-9-8h18v-9.475c0-5.212-4-9.525-9-9.525s-9 4.288-9 9.5V64z","data-fill-colored":"true"}})])])
          )
        }
      }
    